import { render } from "./QuoteItems.vue?vue&type=template&id=25de2024"
import script from "./QuoteItems.vue?vue&type=script&lang=js"
export * from "./QuoteItems.vue?vue&type=script&lang=js"

import "./QuoteItems.vue?vue&type=style&index=0&id=25de2024&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__